import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/pipeable'

const re = /^(0|[1-9]\d*)$/

export function parse(value: string): O.Option<number> {
  return pipe(
    O.fromNullable(value.match(re)),
    O.map((m) => {
      const [wholes] = m.slice(1)
      return Number.parseInt(wholes, 10)
    })
  )
}
